import {useIntl} from "react-intl";
import m from "../definedMessages";

import {isBoolean} from "../utils/helpers";

export const withTranslation = (Component) => {
    const ComponentWithTranslations = (props) => {
        const {formatMessage} = useIntl();

        const formatMessageWithService = (message, service) => {
            if (isBoolean(service)) {
                const serviceMessage = service ? m.calls : m.sms;

                return `${formatMessage(serviceMessage)} ${formatMessage(message)}`;
            }
            return formatMessage(message);
        }

        return (
            <Component
                {...props}
                {...{
                    m,
                    formatMessage: formatMessageWithService
                }}
            />
        );
    }

    return ComponentWithTranslations;
};